import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../styles/colors';
import { useLocation } from 'react-router-dom';
import {
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import Modal from '../../elements/Modal';
import NewBuyer from './new';
import EditBuyer from './edit';

const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;

  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elLightGray};
  padding: 15px;
  padding-left: 50px;
`;

const BoldLinkText = styled(Text)`
  font-weight: bold;
`;

const SubNav = ({buyer, refetch}) => {
  const [showAddBuyerModal, setShowAddBuyerModal] = useState(false);
  const [showEditBuyerModal, setShowEditBuyerModal] = useState(false);
  const location = useLocation();
  return (
    <NavbarContainer>
      {getLinks()}
    </NavbarContainer>
  )

  function getLinks() {
    if(location.pathname === '/buyers') {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddBuyerModal(true)}
          >
            <Text>+ Add Buyer</Text>
          </Pressable>
          {showAddBuyerModal &&
            <Modal
              showModal={showAddBuyerModal}
              setShowModal={setShowAddBuyerModal}
              modalType={'Add Buyer'}
              buyerId={buyer?.id}
            >
              <NewBuyer
                setShowModal={setShowAddBuyerModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(location.pathname === '/buyers/new') {
      return (
        <Link to={`/buyers`}>
          <Text>Buyers</Text>
        </Link>
      )
    }else {
      return (
        <LinkContainer>
          <BoldLinkText>{buyer.displayName}</BoldLinkText>
          <LinkSpace />
          <Pressable
            onPress={() => {
              setShowEditBuyerModal(true)
            }}
          >
            <Text>
              Edit
            </Text>
          </Pressable>
          {showEditBuyerModal &&
            <Modal
              refetch={refetch}
              showModal={showEditBuyerModal}
              setShowModal={setShowEditBuyerModal}
              modalType={'Edit Buyer'}
              objectName={buyer.name}
            >
              <EditBuyer
                setShowModal={setShowEditBuyerModal}
                refetch={refetch}
                buyerDetails={buyer}
              />
            </Modal>
          }
        </LinkContainer>
      )
    }
  }
}

export default SubNav;
